(function () {

  'use strict';

  function pxSiteNetworks(
    $window, $location, EventServiceEvents, TenantListService
  ) {
    return {
      restrict: 'EA',
      scope: {
        me: '=me',
        context: '=context',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/sites/siteNetworks/siteNetworks.template.html',
      link: function (scope) {

        scope.loading = false;
        scope.siteNetworks = [];
        scope.globalSetting = TenantListService.currentTenant.info.clientMigratePrintQueues;

        scope.menuItems = [
          {
            name: 'Remove',
            icon: 'icon-delete',
            action: 'removeSiteNetworks',
            disabled: scope.me.isSystemObserver()
          }
        ];
        scope.listMenuContext = null;
        scope.listMeta = null;

        (function () {
          getSiteNetworks();
          setListeners();
        })();

        function getSiteNetworks() {
          scope.loading = true;
          scope.context.getSiteWithEmbeddedResources().then(function (response) {
            if (response.network) {
              scope.siteNetworks = createTargetUrl(response.network);
            } else {
              scope.siteNetworks = [];
            }
            scope.loading = false;
          }).catch(function(error){
            scope.loading = false;
          });
        }

        function createTargetUrl(networks) {
          const target = $location.absUrl().split('sites/');
          angular.forEach(networks, function (network) {
            const networkID = network._links.self.href.split('networks/')[1];
            network.targetUrl = target[0] + 'networkProperties/' + networkID + '?networkSection=setup';
          });
          return networks;
        }

        scope.openListMenu = function (event, network) {
          scope.listMenuContext = network;
          scope.listMeta = {
            position: { left: event.clientX, top: event.clientY }
          };
        };

        scope.closeListMenu = function (network, action) {
          scope.listMenuContext = null;
          scope.listMeta = null;
          switch (action) {
            case 'removeSiteNetworks':
              removeNetworkFromSite(network);
              break;
          }
        };

        function removeNetworkFromSite(network) {
          scope.context.removeNetworkFromSite(network).then(function (response) {
          }).catch(function(error){});
        }

        scope.gotoProperties = function (network) {
          $window.open(network.targetUrl, '_blank');
        };

        function setListeners() {
          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.NETWORK_CHANGED, function (name, data) {
            getSiteNetworks();
          });
        }

        scope.addNetwork = function () {
          const addNetworkMeta = {
            title: 'AddNetworks',
            type: 'addNetworks'
          };
          scope.callback({ meta: addNetworkMeta });
        };

      }
    };
  }

  pxSiteNetworks.$inject = ['$window', '$location', 'EventServiceEvents', 'TenantListService'];

  angular
    .module('printix-admin')
    .directive('pxSiteNetworks', pxSiteNetworks);

})();
